"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Adornments = void 0;

var _css2 = _interopRequireDefault(require("@emotion/css"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var _stylitas = require("@creditas/stylitas");

var _icons = require("@creditas/icons");

var _propTypes = require("prop-types");

var _Adornment = require("./Adornment");

var _input = require("./input.style");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  adornments: _propTypes.array,
  select: _propTypes.bool,
  multiple: _propTypes.bool,
  success: _propTypes.bool,
  warning: _propTypes.bool,
  error: _propTypes.bool,
  loading: _propTypes.bool,
  search: _propTypes.bool,
  IconSelect: _propTypes.elementType,
  IconSuccess: _propTypes.elementType,
  IconWarning: _propTypes.elementType,
  IconError: _propTypes.elementType,
  IconLoader: _propTypes.elementType,
  IconSearch: _propTypes.elementType
} : {};

const IconChevronDown = props => (0, _core.jsx)(_icons.Navigation.ChevronDown, props);

const IconActionCheck = props => (0, _core.jsx)(_icons.Action.Check, (0, _extends2.default)({
  color: "success"
}, props));

const IconAlertTriangle = props => {
  return (0, _core.jsx)(_icons.Alert.AlertTriangle, (0, _extends2.default)({
    color: "warning"
  }, props));
};

const IconAlertCircle = props => {
  return (0, _core.jsx)(_icons.Alert.AlertCircle, (0, _extends2.default)({
    color: "danger"
  }, props));
};

const IconFileLoader = props => (0, _core.jsx)(_icons.File.Loader, props);

const IconActionSearch = props => (0, _core.jsx)(_icons.Action.Search, props);

const defaultProps = {
  IconSelect: IconChevronDown,
  IconSuccess: IconActionCheck,
  IconWarning: IconAlertTriangle,
  IconError: IconAlertCircle,
  IconLoader: IconFileLoader,
  IconSearch: IconActionSearch,
  adornments: []
};

const Adornments = ({
  IconSelect,
  IconSuccess,
  IconWarning,
  IconError,
  IconLoader,
  IconSearch,
  adornments,
  select,
  multiple,
  success,
  warning,
  error,
  loading,
  search
}) => {
  const newAdornments = [...adornments, select && !multiple && (0, _core.jsx)(IconSelect, {
    key: "iconSelect",
    css: _input.inputIconComponent
  }), search && (0, _core.jsx)(IconSearch, {
    key: "iconSearch",
    css: _input.inputIconComponent
  }), success && (0, _core.jsx)(IconSuccess, {
    key: "iconSuccess",
    css: _input.inputIconComponent
  }), warning && (0, _core.jsx)(IconWarning, {
    key: "iconWarning",
    css: _input.inputIconComponent
  }), error && (0, _core.jsx)(IconError, {
    key: "iconError",
    css: _input.inputIconComponent
  }), loading && (0, _core.jsx)(IconLoader, {
    key: "iconLoader",
    css: /*#__PURE__*/(0, _css2.default)([_input.inputIconComponent, _stylitas.utilities.animation.spin()], process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */")
  })].filter(Boolean);
  return (0, _core.jsx)(_Adornment.Adornment, {
    position: "end"
  }, newAdornments);
};

exports.Adornments = Adornments;
process.env.NODE_ENV !== "production" ? Adornments.propTypes = propTypes : void 0;
Adornments.defaultProps = defaultProps;